'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _api = require('@react-google-maps/api');

var _reactDom = require('react-dom');

var ReactDOM = _interopRequireWildcard(_reactDom);

var _markerwithlabel = require('markerwithlabel');

var _markerwithlabel2 = _interopRequireDefault(_markerwithlabel);

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _helper = require('./helper');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/forbid-prop-types */
/* global google */


var eventMap = {
	onDblClick: 'dblclick',
	onDragEnd: 'dragend',
	onDragStart: 'dragstart',
	onMouseDown: 'mousedown',
	onMouseOut: 'mouseout',
	onMouseOver: 'mouseover',
	onMouseUp: 'mouseup',
	onRightClick: 'rightclick',
	onAnimationChanged: 'animation_changed',
	onClick: 'click',
	onClickableChanged: 'clickable_changed',
	onCursorChanged: 'cursor_changed',
	onDrag: 'drag',
	onDraggableChanged: 'draggable_changed',
	onFlatChanged: 'flat_changed',
	onIconChanged: 'icon_changed',
	onPositionChanged: 'position_changed',
	onShapeChanged: 'shape_changed',
	onTitleChanged: 'title_changed',
	onVisibleChanged: 'visible_changed',
	onZindexChanged: 'zindex_changed'
};

var updaterMap = {
	/**
  * For `MarkerWithLabel`
  * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
  */
	labelAnchor: function labelAnchor(instance, _labelAnchor) {
		instance.set('labelAnchor', _labelAnchor);
	},


	/**
  * For `MarkerWithLabel`
  * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
  */
	labelClass: function labelClass(instance, _labelClass) {
		instance.set('labelClass', _labelClass);
	},


	/**
  * For `MarkerWithLabel`
  * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
  */
	labelStyle: function labelStyle(instance, _labelStyle) {
		instance.set('labelStyle', _labelStyle);
	},


	/**
  * For `MarkerWithLabel`
  * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
  */
	labelVisible: function labelVisible(instance, _labelVisible) {
		instance.set('labelVisible', _labelVisible);
	},
	animation: function animation(instance, _animation) {
		instance.setAnimation(_animation);
	},
	clickable: function clickable(instance, _clickable) {
		instance.setClickable(_clickable);
	},
	cursor: function cursor(instance, _cursor) {
		instance.setCursor(_cursor);
	},
	draggable: function draggable(instance, _draggable) {
		instance.setDraggable(_draggable);
	},
	icon: function icon(instance, _icon) {
		instance.setIcon(_icon);
	},
	label: function label(instance, _label) {
		instance.setLabel(_label);
	},
	opacity: function opacity(instance, _opacity) {
		instance.setOpacity(_opacity);
	},
	options: function options(instance, _options) {
		instance.setOptions(_options);
	},
	place: function place(instance, _place) {
		instance.setPlace(_place);
	},
	position: function position(instance, _position) {
		instance.setPosition(_position);
	},
	shape: function shape(instance, _shape) {
		instance.setShape(_shape);
	},
	title: function title(instance, _title) {
		instance.setTitle(_title);
	},
	visible: function visible(instance, _visible) {
		instance.setVisible(_visible);
	},
	zIndex: function zIndex(instance, _zIndex) {
		instance.setZIndex(_zIndex);
	}
};

var MarkerWithLabel = function (_Component) {
	_inherits(MarkerWithLabel, _Component);

	function MarkerWithLabel() {
		_classCallCheck(this, MarkerWithLabel);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	MarkerWithLabel.prototype.componentDidMount = function componentDidMount() {
		var markerOptions = _extends({}, this.props.options || {}, this.props.clusterer ? {} : { map: this.context }, {
			position: this.props.position
		});

		// Unfortunately we can't just do this in the contstructor, because the
		// `MapContext` might not be filled in yet.
		var NativeMarkerWithLabel = (0, _markerwithlabel2.default)(google.maps);
		this.marker = new NativeMarkerWithLabel(markerOptions);

		if (this.props.clusterer) {
			this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
		} else {
			this.marker.setMap(this.context);
		}

		this.registeredEvents = (0, _helper.applyUpdatersToPropsAndRegisterEvents)({
			updaterMap: updaterMap,
			eventMap: eventMap,
			prevProps: {},
			nextProps: this.props,
			instance: this.marker
		});
		var container = document.createElement('div');
		ReactDOM.unstable_renderSubtreeIntoContainer(this, _react2.default.Children.only(this.props.children), container);
		this.marker.set('labelContent', container);
	};

	MarkerWithLabel.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		if (this.marker) {
			(0, _helper.unregisterEvents)(this.registeredEvents);

			this.registeredEvents = (0, _helper.applyUpdatersToPropsAndRegisterEvents)({
				updaterMap: updaterMap,
				eventMap: eventMap,
				prevProps: prevProps,
				nextProps: this.props,
				instance: this.marker
			});
		}
	};

	MarkerWithLabel.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.marker) {
			(0, _helper.unregisterEvents)(this.registeredEvents);

			if (this.props.clusterer) {
				this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
			} else if (this.marker) {
				if (this.marker.get('labelContent')) {
					ReactDOM.unmountComponentAtNode(this.marker.get('labelContent'));
				}
				this.marker.setMap(null);
			}
		}
	};

	MarkerWithLabel.prototype.render = function render() {
		return this.props.children;
	};

	return MarkerWithLabel;
}(_react.Component);

MarkerWithLabel.contextType = _api.MapContext;

MarkerWithLabel.propTypes = {
	clusterer: _types2.default.props,
	options: _types2.default.props,
	noClustererRedraw: _types2.default.bool,
	position: _types2.default.any,
	children: _types2.default.children
};

MarkerWithLabel.defaultProps = {};

exports.default = MarkerWithLabel;